// extracted by css-extract-rspack-plugin
export default {"indeterminateBar":"_2y0aa","imiTableIndeterminate":"_27Hj8"};